import { render } from "./HomePage.vue?vue&type=template&id=4d4e404c"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=4d4e404c&lang=scss"
script.render = render

export default script